'use client'
import { useTranslations } from 'next-intl'
import { RestaurantCityBrandsLink } from '@/features/restaurants/restaurants-city-search/restaurant-city-brands-link'
import { RestaurantCitySeoDescription } from '@/features/restaurants/restaurants-city-search/restaurant-city-seo-description'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'
import { RestaurantsPageHeading } from '@/features/restaurants/restaurants-page-heading'

interface IRestaurantsCityHeaderProps {
    citySlug: string
}

export const RestaurantsCityHeader = ({ citySlug }: IRestaurantsCityHeaderProps) => {
    const { city } = useRestaurantCitySearchContext()
    const t = useTranslations()

    return (
        <RestaurantsPageHeading
            title={t('restaurants.city.restaurantsIn', { cityName: city?.name ?? '' })}
        >
            {/* Clamped on mobile rather than hidden. The heading and this copy were both
                `hidden md:*`, which left the page Google indexes mobile-first with no
                visible h1 at all. Clamping keeps the full text in the DOM. */}
            <RestaurantCitySeoDescription
                citySlug={citySlug}
                className="line-clamp-3 md:line-clamp-none"
            />

            <RestaurantCityBrandsLink citySlug={citySlug} />
        </RestaurantsPageHeading>
    )
}
